import { getHosts } from '../common/getHosts';
import SpacingStyles from './SpacingStyles';
import { GlobalDesignActionType, GlobalDesignDefaultAction } from '../types';

const spacingAction: GlobalDesignDefaultAction = {
  type: GlobalDesignActionType.Default,
  panel: SpacingStyles,
  getHosts,
};

export default spacingAction;
